module.exports = __webpack_public_path__ + "img/menu.0a461c1a.svg";